import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoGuia from "../pages/artigo-guia/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hoobuy-spreadsheet-guia",
    element: <ArtigoGuia />,
  },
  {
    path: "/hoobuy-vs-pandabuy",
    element: <ArtigoGuia />,
  },
  {
    path: "/melhor-agente-2026",
    element: <ArtigoGuia />,
  },
  {
    path: "/seguranca-hoobuy",
    element: <ArtigoGuia />,
  },
  {
    path: "/melhores-links-hoobuy",
    element: <ArtigoGuia />,
  },
  {
    path: "/nike-hoobuy-guia",
    element: <ArtigoGuia />,
  },
  {
    path: "/jordan-hoobuy-modelos",
    element: <ArtigoGuia />,
  },
  {
    path: "/hoobuy-brasil-iniciantes",
    element: <ArtigoGuia />,
  },
  {
    path: "/economizar-hoobuy-spreadsheet",
    element: <ArtigoGuia />,
  },
  {
    path: "/hoobuy-vs-cnfans",
    element: <ArtigoGuia />,
  },
  {
    path: "/top-produtos-hoobuy",
    element: <ArtigoGuia />,
  },
  {
    path: "/erros-comuns-hoobuy",
    element: <ArtigoGuia />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;